import { Action, createReducer, on } from '@ngrx/store';
import { SecurityUserLoginModel } from 'src/app/model/security/security-user.login';
import { adminUserActions } from './admin-user.action';
import { adminUserIS } from './admin-user.state';

const adminUserRegister = createReducer(
  adminUserIS,
  on(adminUserActions.setResultAction, (state, param) => ({
    ...state,
    ...param,
  })),

  on(adminUserActions.setDefaultAction, (state) => ({
    ...state,
    ...adminUserIS,
  })),

  on(adminUserActions.setAllDefaultAction, () => adminUserIS)
);

export function adminUserReducer(
  state: SecurityUserLoginModel,
  action: Action
): any {
  return adminUserRegister(state, action);
}
